export function playerInfoToLayers(player) {
    let hairLayer = `Hair${player.hairStyle ?? 'Poofy'}${player.hairColor ?? 'Brown'}`;
    if (player.hairStyle === 'bald') {
        hairLayer = '';
    }
    return [
        hairLayer,
        `Head${player.skinTone ?? 'Medium'}`,
        `Body${player.clothing ?? 'Blue'}`,
        "Ghost"
    ];
}
